<template>
  <router-link v-if="link" class="c-tabs__item" :to="link" @click.native="onTabClick" exact>
    <slot></slot>
  </router-link>

  <a
    v-else
    class="c-tabs__item"
    :class="{'is-active': active}"
    href="#"
    @click.prevent="onTabClick"
  >
    <slot></slot>
  </a>
</template>

<script>
export default {
  name: 'tabs-item',

  props: ['link', 'active'],

  methods: {
    onTabClick(e) {
      this.$emit('click');
    },
  },
};
</script>

<style lang="scss">
.c-tabs__item {
  padding: 1em 0;

  float: none;
  display: inline-block;
  height: 50px;
  text-decoration: none;
  color: $colour-nhs-dark-grey;

  &:hover {
    border-color: $colour-nhs-dark-grey;
  }

  &:not(:first-of-type) {
    margin-left: 2em;
  }

  &.is-active {
    color: $colour-nhs-blue;
  }

  @media screen and (min-width: 1024px) {
    display: inline-block;
    float: none;

    border-bottom: 3px solid transparent;
    margin-bottom: -2.5px;

    &.is-active {
      border-color: $colour-nhs-blue;
    }
  }
}
</style>
